module.exports = __webpack_public_path__ + "static/media/20.ebf63e0b.png";